export default {
  authorization: {
    url: window.location.origin + '/docs/rgcc-autorizacion-menor.pdf',
    info: {
      size: '681kb',
      pages: '1 página'
    }
  }
}
